import firebase from 'firebase/app'

import 'firebase/auth'
import 'firebase/storage'

export { firebase }
